import { z } from 'zod';
/** Lo consume el HEALTHCHECK del contenedor y la sonda de App Platform. */
export const esquemaSalud = z.object({
    estado: z.enum(['ok', 'degradado']),
    baseDatos: z.enum(['ok', 'error']),
    version: z.string(),
});
/**
 * Configuración pública que el frontend pide en tiempo de EJECUCIÓN.
 *
 * En la v1 el frontend leía `import.meta.env.VITE_*`, que Vite incrusta en el
 * bundle al compilar: eso ataba la imagen a un entorno y obligaba a tener las
 * variables disponibles en tiempo de build. Acá no hay nada horneado, así que
 * la misma imagen sirve para cualquier entorno.
 */
export const esquemaConfigPublica = z.object({
    entorno: z.enum(['development', 'test', 'production']),
    archivosHabilitados: z.boolean(),
    correoHabilitado: z.boolean(),
});
//# sourceMappingURL=salud.js.map